import React, { useState } from 'react';
import { Copy, Check, Loader2 } from './icons';
import { copyToClipboard } from '../../utils/clipboard';

interface CopyButtonProps {
  text: string;
  size?: number;
  toastMessage?: string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
}

export default function CopyButton({
  text,
  size = 13,
  toastMessage = 'Copied to clipboard',
  className = '',
  style = {},
  color = '#5F719A',
}: CopyButtonProps) {
  const [state, setState] = useState<'idle' | 'loading' | 'copied'>('idle');

  const handleCopy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (state !== 'idle') return;

    setState('loading');

    // Brief loading delay for smooth visual feedback
    await new Promise((resolve) => setTimeout(resolve, 250));

    const success = await copyToClipboard(text, toastMessage);
    if (success) {
      setState('copied');
      setTimeout(() => {
        setState('idle');
      }, 1800);
    } else {
      setState('idle');
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={state === 'copied' ? 'Copied!' : 'Copy'}
      aria-label="Copy"
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'none',
        border: 'none',
        cursor: state === 'loading' ? 'wait' : 'pointer',
        padding: '2px 4px',
        color: state === 'copied' ? '#34C759' : color,
        transition: 'color 0.2s ease, transform 0.15s ease',
        ...style,
      }}
    >
      {state === 'loading' && (
        <Loader2
          size={size}
          className="spin"
          style={{ animation: 'spin 0.8s linear infinite' }}
        />
      )}
      {state === 'copied' && (
        <Check size={size} style={{ color: '#34C759', strokeWidth: 2.5 }} />
      )}
      {state === 'idle' && (
        <Copy size={size} />
      )}
    </button>
  );
}
